import React, { useState, useEffect } from "react";
import _ from 'lodash';
import './change-prices.css';
import {
    Button,
    Form,
    Col,
    Row,
    Container,
    InputGroup,
    Card
  } from "react-bootstrap";
import {useForm} from "react-hook-form";
import axios from 'axios';
import SyncLoader from "react-spinners/SyncLoader";
import GenericModal from '../../generic/modal';
import ReactGA from 'react-ga';

export default function ChangePrices(props) {
    ReactGA.pageview(window.location.pathname + window.location.search);    

    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [success, setSuccess] = useState(Boolean);
    const [clinicData, setclinicData] = useState(props.location.state.clinicData);
    const [prices, setPrices] = useState({});

    // let history = useHistory();
    // let displayPrices = {}; 
    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            invisalign_consultation: prices.invisalign_consultation,
            implant_consultation:    prices.implant_consultation,
            veneers_consultation:    prices.veneers_consultation,
            emergency:               prices.emergency,
            teeth_whitening_homekit: prices.teeth_whitening_homekit,
            teeth_whitening_clinic:  prices.teeth_whitening_clinic,
            second_opinion:          prices.second_opinion,
            dental_checkup:          prices.dental_checkup,
            check_clean:             prices.check_clean,
            teeth_cleaning:          prices.teeth_cleaning,
            cosmetic_consultation:   prices.cosmetic_consultation,
            online_dentist:          prices.online_dentist,
        }
    });


    useEffect(() => {
        axios.post('https://uae-dentist-backend.herokuapp.com/account/get-prices', {_id: props.location.state.clinicData.prices} )
        .then ((prices) => {
            console.log(prices.data)
            reset(prices.data)
            setPrices(prices.data);
            // setLoading(false);
        })
      }, [props.location.state.clinicData, reset]);

    const onSubmit = async (data) => {
        let postData = {};
        setLoading(true);
        for (var propName in data) { 
            if (data[propName] === null || data[propName] === undefined || data[propName] === '' || data[propName] === '- Please Select -') {
              delete data[propName];
            }
        }
        const token = localStorage.getItem('token');
        const axiosConfig = {
            headers: {
                Authorization: token
            }
        };
        postData._id = clinicData.prices;
        postData.prices = data;
        await axios.post('https://uae-dentist-backend.herokuapp.com/account/update-prices', postData, axiosConfig)
        .then(function (response) {
            _.extend(props.location.state.clinicData.prices, data);
            setSuccess(true);
            setShow(true);
            setclinicData(response.data);
            setLoading(false);
        })
        .catch(function (error) {
            setSuccess(false);
            setShow(true);
            setLoading(false);
            console.log(error);
        })
    } 
    


    return (
    <Container className="mt-5 rounded">
    { show && <GenericModal setShow={setShow} show={show} success={success}/>}
    <Form onSubmit={handleSubmit(onSubmit)}>

        <Row xs={1} md={2} lg={2}>

                <Col>
                    <Card>
                        <Card.Header><h3>Main Services</h3></Card.Header>
                        <Card.Body>

                            <Form.Group >
                                <Form.Label>Emergency - Toothpain/Broken tooth </Form.Label><InputGroup className="mb-2"><InputGroup.Append><InputGroup.Text>AED</InputGroup.Text></InputGroup.Append>
                                <Form.Control type='number' min="0" step=".01" name="emergency" ref={register} placeholder={'Loading...'}/></InputGroup>
                            </Form.Group>

                            <Form.Group >
                                <Form.Label>Dental Checkup </Form.Label><InputGroup className="mb-2"><InputGroup.Append><InputGroup.Text>AED</InputGroup.Text></InputGroup.Append>
                                <Form.Control type='number' min="0" step=".01" name="dental_checkup" ref={register} placeholder={'Loading...'}/></InputGroup>
                            </Form.Group>

                            <Form.Group >
                                <Form.Label>Teeth Cleaning </Form.Label><InputGroup className="mb-2"><InputGroup.Append><InputGroup.Text>AED</InputGroup.Text></InputGroup.Append>
                                <Form.Control type='number' min="0" step=".01" name="teeth_cleaning" ref={register} placeholder={'Loading...'}/></InputGroup>
                            </Form.Group>

                            <Form.Group >
                                <Form.Label>Teeth Whitening </Form.Label><InputGroup className="mb-2"><InputGroup.Append><InputGroup.Text>AED</InputGroup.Text></InputGroup.Append>
                                <Form.Control type='number' min="0" step=".01" name="teeth_whitening" ref={register} placeholder={'Loading...'}/></InputGroup>
                            </Form.Group>

                            <Form.Group >
                                <Form.Label>Online Dentist</Form.Label><InputGroup className="mb-2"><InputGroup.Append><InputGroup.Text>AED</InputGroup.Text></InputGroup.Append>
                                <Form.Control type='number' min="0" step=".01" name="online_dentist" ref={register} placeholder={'Loading...'}/></InputGroup>
                            </Form.Group>



                        </Card.Body>
                    </Card>
                </Col>


                    <Col>
                        <Card>
                            <Card.Header><h3>Optional Services</h3></Card.Header>
                            <Card.Body>
                            <Form.Group >
                                <Form.Label>Invisalign Consultation</Form.Label><InputGroup className="mb-2"><InputGroup.Append><InputGroup.Text>AED</InputGroup.Text></InputGroup.Append>
                                <Form.Control type='number' min="0" step=".01" name="invisalign_consultation" ref={register} placeholder={'Loading...'}/></InputGroup>
                            </Form.Group>

                            <Form.Group >
                                <Form.Label>Implant Consultation </Form.Label><InputGroup className="mb-2"><InputGroup.Append><InputGroup.Text>AED</InputGroup.Text></InputGroup.Append>
                                <Form.Control type='number' min="0" step=".01" name="implant_consultation" ref={register} placeholder={'Loading...'}/></InputGroup>
                            </Form.Group>

                            <Form.Group >
                                <Form.Label>Veneers Consultation</Form.Label><InputGroup className="mb-2"><InputGroup.Append><InputGroup.Text>AED</InputGroup.Text></InputGroup.Append>
                                <Form.Control type='number' min="0" step=".01" name="veneers_consultation" ref={register} placeholder={'Loading...'}/></InputGroup>
                            </Form.Group>

                            <Form.Group >
                                <Form.Label>Second Opinion</Form.Label><InputGroup className="mb-2"><InputGroup.Append><InputGroup.Text>AED</InputGroup.Text></InputGroup.Append>
                                <Form.Control type='number' min="0" step=".01" name="second_opinion" ref={register} placeholder={'Loading...'}/></InputGroup>
                            </Form.Group>


                            <Form.Group >
                                <Form.Label>Check Clean</Form.Label><InputGroup className="mb-2"><InputGroup.Append><InputGroup.Text>AED</InputGroup.Text></InputGroup.Append>
                                <Form.Control type='number' min="0" step=".01" name="check_clean" ref={register} placeholder={'Loading...'}/></InputGroup>
                            </Form.Group>
        
                            <Form.Group >
                                <Form.Label>Cosmetic Consultation </Form.Label><InputGroup className="mb-2"><InputGroup.Append><InputGroup.Text>AED</InputGroup.Text></InputGroup.Append>
                                <Form.Control type='number' min="0" step=".01" name="cosmetic_consultation" ref={register} placeholder={'Loading...'}/></InputGroup>
                            </Form.Group>



                            </Card.Body>
                        </Card>
                        <Button variant="primary" className='my-4' type="submit">
                            Update Prices
                        </Button>
                    </Col>

                <div className='mt-5'>

                <SyncLoader
                    size={15}
                    margin={2}
                    color={"#123abc"}
                    loading={loading}
                />

                </div>
                </Row>
            </Form>
        </Container>
    )
    
}